import { connect } from 'react-redux';
import pipe from 'lodash/fp/pipe.js';

import {
  selectAuthUserTokenIsSet,
  selectAuthUserOrgHasExtractionAccess,
} from '#selectors/entities/users.js';
import withRouteParams from '#components/support/routing/withRouteParams/index.jsx';
import RequireExtractionPermission from './RequireExtractionPermission.jsx';

const mapStateToProps = state => ({
  hasExtractionAccess: selectAuthUserOrgHasExtractionAccess(state),
  isAuthenticated: selectAuthUserTokenIsSet(state),
});

export default pipe(connect(mapStateToProps), withRouteParams)(RequireExtractionPermission);
